import React from "react";
import styled from "styled-components";
import Button from "../components/Button";
import { device } from "../utils/devices";
import Footer from "../components/Footer";
import bg from "../assets/soccer-min.jpg";
import useEvents from "../hooks/useEvents";
import EventCard from "../components/EventCard";

const Wrapper = styled.div`
  width: 90vw;
  margin: 2rem auto 4rem;
  font-family: ${props => props.theme.type.new};
  color: rgb(51, 51, 51);
  line-height: 1.4em;
  font-size: 16px;

  @media ${device.laptop} {
    font-size: 30px;
    margin: 0 auto 4rem;
  }

  a {
    color: white;
    text-decoration: none;
  }

  aside {
    margin-top: 2rem;

    @media (orientation: landscape) {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 5vw;
    }

    @media ${device.laptop} {
      grid-column-gap: 2rem;
    }

    h4 {
      margin: 1rem 0;

      @media ${device.laptop} {
        margin: 0.5rem 0;
      }

      &.title {
        font-size: 64px;
        line-height: 64px;
        margin: 2rem 0 1.5rem;
        font-family: ${props => props.theme.type.heading};

        @media (orientation: landscape) {
          font-size: 24px;
        }

        @media ${device.laptop} {
          font-size: 80px;
          line-height: 80px;
          margin: 1rem 0;
        }

        sup {
          font-size: 30px;
          line-height: 30px;
          vertical-align: baseline;

          @media (orientation: landscape) {
            font-size: 36px;
            line-height: 36px;
          }

          @media ${device.laptop} {
            vertical-align: super;
          }

          .small {
            font-size: 18px;

            @media ${device.laptop} {
              font-size: 24px;
            }
          }

          sup {
            font-size: 18px;
            vertical-align: super;
          }
        }
      }
    }

    h3 {
      margin: 1rem 0 0;
    }

    button {
      width: 100%;

      @media ${device.laptop} {
        width: auto;
      }
    }

    h2 {
      grid-column: span 3;
      text-transform: uppercase;
      font-size: 18px;
      text-align: center;

      @media ${device.laptop} {
        font-size: 1.5vw;
      }
    }
  }
`;

const Hero = styled.div`
  background: ${props => (props.bg ? `url(${props.bg})` : `black`)};
  font-family: ${props => props.theme.type.new};
  background-size: cover;
  line-height: 1.4em;
  font-size: 18px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 6rem 0 2rem;

  @media ${device.laptop} {
    height: 70vh;
    font-size: 24px;
    padding: 0;
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
    opacity: 0.6;
    background-image: url(data:image/png;base64,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);
  }

  main {
    margin: 0 auto;
    color: white;
    width: 90vw;
    max-width: 1100px;
    position: relative;
    z-index: 2;

    p {
      text-align: center;
    }

    h2 {
      font-size: 48px;
      text-align: center;
      font-weight: normal;
      font-family: ${props => props.theme.type.heading};
      line-height: 48px;
      text-transform: uppercase;
      margin-bottom: 1rem;

      @media ${device.laptop} {
        font-size: 5vw;
        line-height: 5vw;
      }
    }
  }

  button {
    margin-bottom: 1rem;
  }
`;

const ButtonGroup = styled.div`
  display: grid;
  grid-gap: 1rem;

  @media ${device.laptop} {
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;
  }

  button {
    width: 100%;
    background: transparent !important;
    border-color: white !important;
    color: white !important;
    font-size: 18px;
    height: auto;

    &:hover {
      background: white !important;
      color: black !important;
    }
  }
`;

const LoadMore = styled.div`
  margin: 2rem 0 0;
  display: flex;
  /* border-top: 1px solid rgba(0,0,0,0.12); */
  padding-top: 2rem;
  justify-content: center;

  @media ${device.laptop} {
    button {
      width: 29vw;
    }
  }
`;

const Community = () => {
  const { loaded, events, pageSize, setPageSize } = useEvents();

  return (
    <>
      <Hero bg={bg}>
        <main>
          <h2>Join the Foul Community</h2>
          <p>
            Foul is a sports brand rooted in community. Join our Whatsapp group
            or follow us on IG to get involved with our events, pick-up games
            and connect with other like-minds around the world. Be a part of the
            team.
          </p>
          <br />
          <ButtonGroup>
            <a href="https://instagram.com/foulstudios">
              <Button>Follow Us on Instagram</Button>
            </a>
            <a href="https://api.whatsapp.com/send?phone=19177910756&text=Sign%20me%20up%20to%20the%20broadcast%20on%20Foul%20events%20in%20NYC%20%F0%9F%8C%8D%F0%9F%8F%86%F0%9F%8E%BE%F0%9F%8F%80">
              <Button>Sign Up to the Whatsapp Broadcast</Button>
            </a>
          </ButtonGroup>
        </main>
      </Hero>
      <Wrapper>
        {loaded && (
          <>
            <aside>
              {events.map(({ data }, index) => (
                <EventCard
                  key={index}
                  date={data.time}
                  title={data.title[0].text}
                  recap={data.recap}
                  description={data.description}
                  image={data.image.url}
                  venue={data.venue[0].text}
                />
              ))}
            </aside>
            <LoadMore>
              {events.length > 0 && events.length % 3 === 0 && (
                <Button secondary onClick={() => setPageSize(pageSize + 3)}>
                  Load More Events
                </Button>
              )}
            </LoadMore>
          </>
        )}
      </Wrapper>
      <Footer padded />
    </>
  );
};

export default Community;
